export const SJA_APPROVER_ROLES = ["verneombud", "daglig_leder", "annen_leder"];

function asList(value) {
  return Array.isArray(value) ? value.filter(Boolean).map(String) : [];
}

export function emptySjaApproval() {
  return {
    required_roles: [],
    recorded: [],
    pending_roles: [],
    current_user_roles: [],
    current_user_can_approve: false,
    complete: false,
  };
}

export function normalizeSjaApproval(raw) {
  const record = raw && typeof raw === "object" ? raw : {};
  const source =
    record.approval && typeof record.approval === "object" ? record.approval : record;
  if (!source || typeof source !== "object") return emptySjaApproval();
  return {
    required_roles: asList(source.required_roles),
    recorded: Array.isArray(source.recorded) ? source.recorded : [],
    pending_roles: asList(source.pending_roles),
    current_user_roles: asList(source.current_user_roles),
    current_user_can_approve: source.current_user_can_approve === true,
    complete: source.complete === true,
  };
}

export function sjaNotEditable(record) {
  if (!record || typeof record !== "object") return false;
  if (record.not_editable === true) return true;
  if (record.editable === false) return true;
  return (record.status || "draft") !== "draft";
}

export function sjaWorkflowActions({ record, canEdit = false } = {}) {
  const status = record?.status || "draft";
  const approval = normalizeSjaApproval(record);
  const notEditable = sjaNotEditable(record);
  const pendingRoles = approval.pending_roles || [];
  const userRoles = approval.current_user_roles || [];
  const canApprove = approval.current_user_can_approve === true;
  const approveRoles = canApprove
    ? userRoles.filter((role) => pendingRoles.includes(role) && SJA_APPROVER_ROLES.includes(role))
    : [];

  return {
    status,
    approval,
    notEditable,
    canSubmit: canEdit && status === "draft",
    canApprove,
    approveRoles,
    canApproveGeneric: canApprove && approveRoles.length === 0,
    canEditRecord: canEdit && !notEditable,
    canEditStatus: false,
  };
}
